var _desc, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "235.46511627906978 235.75581395348837 25 25",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 247.9651162791 248.2558139535)",
    id: "UY20jRLgypWe1Ps_ai-ZO"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(15,129,254)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12, -12)",
    d: "M 0 12 C 0 5.37258 5.37258 0 12 0 C 18.62742 0 24 5.37258 24 12 C 24 18.62742 18.62742 24 12 24 C 5.37258 24 0 18.62742 0 12 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 247.9651162791 248.2558139535)",
    id: "vcch8S7qEZstzQUbcgDVJ"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(255,255,255)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-9, -9.23439)",
    d: "M 9.5625 3.23438 C 9.5625 2.92371 9.31066 2.67188 9 2.67188 C 8.68934 2.67188 8.4375 2.92371 8.4375 3.23438 L 8.4375 8.67188 L 3 8.67188 C 2.68934 8.67188 2.4375 8.92372 2.4375 9.23438 C 2.4375 9.54503 2.68934 9.79688 3 9.79688 L 8.4375 9.79688 L 8.4375 15.2344 C 8.4375 15.545 8.68934 15.7969 9 15.7969 C 9.31066 15.7969 9.5625 15.545 9.5625 15.2344 L 9.5625 9.79688 L 15 9.79688 C 15.3107 9.79688 15.5625 9.54503 15.5625 9.23438 C 15.5625 8.92372 15.3107 8.67188 15 8.67188 L 9.5625 8.67188 L 9.5625 3.23438 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.6c80c747ba079fc7e9f5a0b6e9740bb2.svg";
export { ForwardRef as ReactComponent };